import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

const Fumo = ({ current, auth, system, stat }) => {
    const sup = system.store.state.ingr.supervisione_ingressi === true
    const [esclusoChecked, setEsclusoChecked] = useState(() => !!(current.escluso || stat.escluso_led));

    useEffect(() => {
        setEsclusoChecked(stat.escluso_led);
    }, [stat.escluso_led]);
    
    const handleEsclusoChange = (e) => {
        setEsclusoChecked(e.target.checked);
    };

    return (
        <fieldset>
            <div className="rack bottomBorder">
                <div className="w33">
                    <div className="switchButton">
                        <input type="checkbox" className="switch" id="escluso" name="escluso" defaultValue="0" checked={esclusoChecked} onChange={handleEsclusoChange} />
                        <label htmlFor={`escluso`}>
                            <span>
                                <span />
                            </span>
                            <FormattedMessage id="App.info.Escluso" />
                        </label>
                    </div>
                </div>
                <div className="w33">
                    <div className="switchButton">
                        <input type="checkbox" className="switch" id="supervisione" name="supervisione" defaultValue="0" defaultChecked={current.supervisione} disabled={auth !== 2 || sup} />
                        <label htmlFor={`supervisione`}>
                            <span>
                                <span />
                            </span>
                            <FormattedMessage id="App.info.Supervisione" />
                        </label>
                    </div>
                </div>
                <div className="w33">
                    <div className="switchButton">
                        <input type="checkbox" className="switch" id="led_on" name="led_on" defaultValue="0" defaultChecked={current.led_on} disabled={auth !== 2 || sup} />
                        <label htmlFor={`led_on`}>
                            <span>
                                <span />
                            </span>
                            <FormattedMessage id="App.info.LedOn" />
                        </label>
                    </div>
                </div>
            </div>
        </fieldset>
    );
};

export default Fumo;